import { bm } from '@core-utils/bem';
import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Button.module.scss';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: 'outlined' | 'contained' | 'text';
    color?: 'magenta' | 'blue' | 'inherit';
    busy?: boolean;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
    { className, variant, busy, disabled, color, ...props },
    ref,
) {
    const modifier =
        variant && color
            ? `${variant}-${color}`
            : variant
              ? `${variant}`
              : color
                ? `contained-${color}`
                : null;
    return (
        <button
            className={cn(
                'form__button',
                styles.Button,
                modifier && styles[`Button--${modifier}`],
                busy && styles['Button--loading'],
                className,
            )}
            disabled={busy || disabled}
            ref={ref}
            {...props}
        />
    );
});

export { Button };
